import { useId, useMemo } from 'react';

/**
 * Used to provide a stable name for a form field that can
 * be used to register the field with react-hook-forms
 *
 * @param name - is the provided name for the field
 * @returns a string that can be used as the field name
 */
function useName(name) {
    const fieldNameId = useId();
    return useMemo(() => 
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- want "" to also be falsy
    name || `generated-text-${fieldNameId}`, [fieldNameId, name]);
}

export { useName };
//# sourceMappingURL=useName.js.map
